import React from 'react';

const JS_HTML_DOM = () => {
  return (
    <div >
      <h1>JS_HTML_DOM</h1>
      <p>Placeholder component for: "JS HTML DOM"</p>
    </div>
  );
};

export default JS_HTML_DOM;
